import React, { createContext, useContext, useState, useEffect } from "react";

import { loginCustomer, registerCustomer } from "../services/source";

// Create Context

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);

  const [token, setToken] = useState(null);

  const [loading, setLoading] = useState(true);

  // Load customer when app starts

  useEffect(() => {
    const savedCustomer = localStorage.getItem("customer");

    const savedToken = localStorage.getItem("token");

    if (savedCustomer && savedToken) {
      setCustomer(JSON.parse(savedCustomer));

      setToken(savedToken);
    }

    setLoading(false);
  }, []);

  // LOGIN

  const login = async (email, password) => {
    const response = await loginCustomer({
      email,
      password,
    });

    if (response.data.success) {
      const user = response.data.customer;

      const userToken = response.data.token;

      setCustomer(user);

      setToken(userToken);

      localStorage.setItem("customer", JSON.stringify(user));

      localStorage.setItem("token", userToken);

      return {
        success: true,

        message: response.data.message,
      };
    }

    return {
      success: false,

      message: response.data.message,
    };
  };

  // REGISTER

  const register = async (data) => {
    const response = await registerCustomer(data);

    if (response.data.success) {
      return {
        success: true,

        message: response.data.message,
      };
    }

    return {
      success: false,

      message: response.data.message,
    };
  };

  // LOGOUT

  const logout = () => {
    setCustomer(null);

    setToken(null);

    localStorage.removeItem("customer");

    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{
        customer,

        token,

        loading,

        login,

        register,

        logout,

        isLoggedIn: !!customer,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook

export const useAuth = () => {
  return useContext(AuthContext);
};
